import { render } from "./g-intranet-layout__navbar.vue?vue&type=template&id=1e6a0dde&ts=true"
import script from "./g-intranet-layout__navbar.vue?vue&type=script&lang=tsx"
export * from "./g-intranet-layout__navbar.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__